import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import { ToastContainer, toast, useToast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { GrClose } from "react-icons/gr";
import { MdDoNotDisturb, MdOutlineFileCopy } from "react-icons/md";
import { BsDatabaseFillAdd, BsThreeDotsVertical } from "react-icons/bs";
import { Menu, MenuItem } from "@mui/material";
import { useCompany } from "../hooks/hooks";
import Button from "react-bootstrap/Button";
import ExcelDownloadButton from "../utils/ExcelDownloader";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import * as dayjs from "dayjs";
import Textarea from "@mui/joy/Textarea";
import ClipLoader from "react-spinners/ClipLoader";
import { Switch, FormControlLabel } from "@mui/material";
import CompanyHeader from "../Components/CompanyHeader";
import UserMenuAccessModal from "../Components/UserMenuAccessModal";
import StorageStatusWidget from "../Components/StorageStatusWidget";
import Lottie from "lottie-react";
import {
  Box,
  Typography,
  Paper,
  Modal,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table
} from "@mui/material";
import databaseAnim from "./database.json";
// import { QRCodeSVG } from 'qrcode.react';
import QRCode from 'qrcode';
import { jsPDF } from 'jspdf';
import { SettingsApplications } from "@mui/icons-material";
import StorageStatusLoader from "../Components/StorageStatusLoader";
import DatabaseStorageWidget from "../Components/DatabaseStorageWidget";
import DatabaseStorageDialog from "../Components/DatabaseStorageDialog";

const img_url = `https://application.eterp.in/files/master/`;
const base_url = "https://application.eterp.in/";
// const base_url = "http://127.0.0.1:7081/";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" },
  maxWidth: 600,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflowY: "auto",
  border: "none",
};

const style2 = {
  position: "absolute",
  top: "50%", // center vertically
  left: "50%", // center horizontally
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "60%" }, // responsive width
  maxHeight: "90%", // prevent overflow
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 3, // modern rounded corners
  overflowY: "auto", // scroll if content too long
};

const Inputs = [
  { name: "database", placeholder: "Database Name" },
  { name: "username", placeholder: "User Name" },
  { name: "key", placeholder: "Key" },
  { name: "password", placeholder: "Database Password" },
];

const apis = [
  {
    type: "Upload",
    name: "Barcode",
    api: "barcodes/insertMany",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Bilty In Report",
    api: "bilityin",
    clear_api: "bilityin/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Bilty Out Report",
    api: "bilityout",
    clear_api: "bilityout/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Broker",
    api: "broker",
    clear_api: "salesmen/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "City",
    api: "cities",
    clear_api: "cities/clear",
    post_response_api: "",
    update_api: "",
    message: "",
  },
  {
    type: "Upload",
    name: "Color",
    api: "colors",
    clear_api: "",
    post_response_api: "",
    update_api: "",
    message: "",
  },
  {
    type: "CheckInUpdate",
    name: "CheckInUpdate",
    api: "checkandupdate",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Department",
    api: "departments",
    clear_api: "",
    post_response_api: "",
    update_api: "",
    message: "",
  },
  {
    type: "Download",
    name: "DesignImagesList",
    api: "products/pendingimagelist",
    clear_api: "",
    post_response_api: "products/tickdownload",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Design",
    api: "products",
    clear_api: "",
    post_response_api: "",
    update_api: "",
    message: "",
  },
  {
    type: "Upload",
    name: "DesignGroup",
    api: "design_group",
    clear_api: "",
    post_response_api: "",
    update_api: "",
    message: "",
  },
  {
    type: "Download",
    name: "Design",
    api: "/products/getProductDetailsforDownload",
    clear_api: "",
    post_response_api: "/products/productdownloaded",
    update_api: "",
    message: "",
  },

  {
    type: "Upload",
    name: "Exhibition Design",
    api: "mstexhibition",
    clear_api: "",
    post_response_api: "",
    update_api: "",
    message: "",
  },

  {
    type: "Upload",
    name: "Exhibition Design Images",
    api: "mstexhibition/uploadimage",
    clear_api: "",
    post_response_api: "",
    update_api: "",
    message: "/:ID inupdate",
  },

  {
    type: "Upload",
    name: "FIFO Report",
    api: "FIFOStockRptTranWise/bulk",
    clear_api: "FIFOStockRptTranWise/clear",
    post_response_api: "",
    update_api: "",
    message: "/:ID inUpdate",
  },

  {
    type: "Upload",
    name: "Financial Year",
    api: "TabFinancialYear",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "HSN",
    api: "hsn",
    clear_api: "hsn/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Ledger",
    api: "buyers/add",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Process",
    api: "process",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Download",
    name: "Purchase",
    api: "purchase/download",
    clear_api: "",
    post_response_api: "purchase/tickdownload",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Purchase Design wise Report",
    api: "pr/designwise",
    clear_api: "pr/designwise/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Download",
    name: "Purchase Order",
    api: "purchaseorders/download",
    clear_api: "",
    post_response_api: "purchaseorders/tickdownload",
    update_api: "purchaseorders/update",
  },
  {
    type: "Upload",
    name: "Purchase Order Close Report",
    api: "purchaseorders/close",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Purchase Order Report",
    api: "pr/orderoutstanding",
    clear_api: "pr/orderoutstanding/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Purchase Return Design Wise Report",
    api: "pr/returndesignwise",
    clear_api: "pr/returndesignwise/clear",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Product",
    api: "mstproducts",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },



  {
    type: "Upload",
    name: "Pattern",
    api: "patterns",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Set",
    api: "mstsets",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Sale Design wise Report",
    api: "sr/designwise",
    clear_api: "sr/designwise/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Download",
    name: "Sale",
    api: "sale/download",
    clear_api: "",
    post_response_api: "sale/tickdownload",
    update_api: "",
  },
  {
    type: "Download",
    name: "Sale Order",
    api: "saleorders/download",
    clear_api: "",
    post_response_api: "saleorders/tickdownload",
    update_api: "seorders/update",
  },

  {
    type: "Upload",
    name: "Sale Order Close Report",
    api: "saleorders/close",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Sale Order Report",
    api: "sr/orderoutstandingList",
    clear_api: "sr/orderoutstandingList/clear",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Sale Return Design Wise Report",
    api: "sr/returndesignwise",
    clear_api: "sr/returndesignwise/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Salesman",
    api: "salesmen",
    clear_api: "salesmen/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Seller",
    api: "sellers/add",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Size",
    api: "sizes",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "State",
    api: "states",
    clear_api: "states/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Stock Report",
    api: "stock",
    clear_api: "stock/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Sundry",
    api: "sundry",
    clear_api: "sundry/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Supplier Design",
    api: "supplydesign",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Top Company Creditor Report",
    api: "topcompanies_credit",
    clear_api: "topcompanies_credit/clear",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Top Company Debtor Report",
    api: "topcompanies_debit",
    clear_api: "topcompanies_debit/clear",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "Top Design Creditor Report",
    api: "topdesigns_credit",
    clear_api: "topdesigns_credit/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Top Design Debtor Report",
    api: "topdesigns_debit",
    clear_api: "topdesigns_debit/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "Transport",
    api: "transport",
    clear_api: "salesmen/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "WIP Report",
    api: "wip",
    clear_api: "wip/clear",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Download",
    name: "ImagePath",
    api: "files",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Upload",
    name: "VoucherSeries",
    api: "series_generator",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Check&Download",
    name: "Design",
    api: "products/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "Ledger",
    api: "buyers/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "Product",
    api: "mstproducts/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "SupplyDesign",
    api: "supplydesign/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "Sundry",
    api: "sundry/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "Broker",
    api: "broker/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "Transport",
    api: "transport/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "SalesMan",
    api: "salesmen/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "Process",
    api: "process/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },

  {
    type: "Check&Download",
    name: "HSN",
    api: "hsn/check",
    clear_api: "",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "TallyOutstanding",
    api: "LeadgerTallyOutStanding",
    clear_api: "LeadgerTallyOutStanding",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "MISConfig",
    api: "MISConfiguration",
    clear_api: "MISConfiguration/clear",
    post_response_api: "",
    update_api: "",
  },
  {
    type: "Upload",
    name: "MISStockReport",
    api: "StockMIS",
    clear_api: "StockMIS/clear",
    post_response_api: "",
    update_api: "",
  },
];

const sortedApis = [...apis].sort((a, b) =>
  a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
);

const EditInputs = [
  { name: "company_name", placeholder: "Company Name" },
  { name: "mobile_no", placeholder: "Mobile No" },
  { name: "email", placeholder: "Email" },
  { name: "gst_no", placeholder: "Gst No" },
  { name: "address", placeholder: "Address" },
  { name: "city", placeholder: "City" },
  { name: "state", placeholder: "State" },
  { name: "pin_code", placeholder: "Pin Code" },
  { name: "no_of_devices", placeholder: "No of Devices" },
  { name: "watermark_text", placeholder: "Water Mark Text" },
  { name: "database_name", placeholder: "Database", disabled: true },
  { name: "web_address", placeholder: "Web Address" },
  { name: "phone_no", placeholder: "Alternative Mobile Number" },
  { name: "notes", placeholder: "Notes" },

];

export const Home = () => {
  const { companySelector, company } = useCompany();
  const [tosearch, setToSearch] = useState("");
  const [renewable_date, setRenewableDate] = useState();
  const [company_history, setCompanyHistory] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [accessSheetVisible, setAccessSheetVisible] = useState(false);
  const [loadingAccess, setLoadingAccess] = useState(false);
  const [accessData, setAccessData] = useState([]);
  const [loading, setloading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const open_menu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const [selectedImage, setSelectedImage] = useState(null);
  const [logo, setLogo] = useState();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
    setLogo(file);
  };

  const [companies, setCompanies] = useState([]);
  const [filter_companies, setFilterCompanies] = useState([]);
  const navigate = useNavigate();
  const [add_db, setAddDB] = useState({});
  const [open, setOpen] = useState(false);
  const [selected_company, setSelectedCompany] = useState("");
  const [edit_company, setEditCompany] = useState({});
  const [remark, setRemark] = useState("");
  const [is_exhibtion_acces, setIsExhebtionAccess] = useState(false);
  const [is_eshow_acces, setIsEshowAcces] = useState(false);
  const [filterStatus, setFilterStatus] = useState("active");
  const handleEditCompany = (e) => {
    const { name, value } = e.target;
    setEditCompany({
      ...edit_company,
      [name]: value,
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddDB({ ...add_db, [name]: value });
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openRC, setOpenRC] = useState(false);
  const handleOpenRC = () => setOpenRC(true);
  const handleCloseRC = () => setOpenRC(false);

  const [openRC1, setOpenRC1] = useState(false);
  const handleOpenRC1 = () => setOpenRC1(true);
  const handleCloseRC1 = () => setOpenRC1(false);

  const [open1, setOpen1] = useState(false);

  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [open2, setOpen2] = useState(false);

  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const [open2s, setOpen2s] = useState(false);

  const handleOpen2s = () => setOpen2s(true);
  const handleClose2s = () => setOpen2s(false);

  const [open3s, setOpen3s] = useState(false);

  const handleOpen3s = () => setOpen3s(true);
  const handleClose3s = () => setOpen3s(false);



  const [openSync, setOpenSync] = useState(false);
  const [ApiError, setApiError] = useState({});

  const handleOpenSync = () => setOpenSync(true);
  const handleCloseSync = () => setOpenSync(false);

  const [isLoading, setIsLoading] = useState(false);

  const [copied_endpoint, setCopiedEndPoint] = useState("");

  let [color, setColor] = useState("#ffffff");
  const [isSetWise, setIsSetWIse] = useState();
  const [isWaterMarkLogo, setIsWaterMarkLogo] = useState(false);

  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "#fff",
  };

  const handleFilter = (type, companyList = companies) => {
    console.log(type);
    const filters = {
      all: companyList,
      active: companyList?.filter((c) => c?.isActive),
      inactive: companyList?.filter((c) => !c?.isActive),
    };

    setFilterCompanies(filters[type] ?? companyList);
  };

  const getCompanies = async () => {
    try {
      let res = await axios("https://application.eterp.in/company/master");
      console.log(res);
      if (res.data.success) {
        setCompanies(res.data.data);
        handleFilter(filterStatus, res.data.data);
        console.log(res.data.data);
      } else {
        console.log(res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateCompany = async (id, payload) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      Object.entries(payload).map(([key, value]) =>
        formData.append(key, value)
      );
      logo !== undefined && formData.append("logo", logo);

      let res = await axios.patch(
        `https://application.eterp.in/company/master/${id}`,
        formData
      );
      console.log(res);
      if (res.data.success) {
        getCompanies();
        handleClose2();
        toast(res.data.message);
        setIsLoading(false);
        setSelectedImage(null);
        setLogo();
      } else {
        console.log(res.data.message);
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const toggleActiveCompany = async (id, isActive) => {
    setIsLoading(true);
    try {
      let res = await axios.patch(
        `https://application.eterp.in/company/togglecompany/master/${id}`,
        { isActive }
      );
      console.log(res);
      if (res.data.success) {
        getCompanies();
        handleClose2();
        toast(res.data.message);
        setIsLoading(false);
        setSelectedImage(null);
        setLogo();
      } else {
        console.log(res.data.message);
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const addDatabase = async (id) => {
    setIsLoading(true);
    const formData = new FormData();
    Object.entries(add_db).map(([key, value]) => formData.append(key, value));

    try {
      let res = await axios.patch(
        `https://application.eterp.in/company/database/master/${id}`,
        add_db
      );

      if (res.data.success) {
        getCompanies();
        toast(res.data.message);
        handleClose();
        setIsLoading(false);
      } else {
        toast(res.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);

      console.error("Axios error:", error);

      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  const searchCompany = async (tosearch) => {
    setIsLoading(true);
    try {
      if (tosearch.length === 0) {
        setFilterCompanies(companies);
        setSuggestions([]);
        setShowSuggestions(false);
        setIsLoading(false);
        return;
      }

      let res = await axios.get(
        `https://application.eterp.in/company/filter/master?tosearch=${tosearch}`
      );

      if (res.data.success) {
        handleFilter(filterStatus, res.data.data);
        setSuggestions(res.data.data.map((i) => i.company_name)); // extract only names
        setShowSuggestions(true);
      }
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  };

  const renewCompany = async (id, payload) => {
    setIsLoading(true);
    try {
      let res = await axios.patch(
        `https://application.eterp.in/company/renew/master/${id}`,
        payload
      );
      console.log(res);
      if (res.data.success) {
        getCompanies();
        handleCloseRC();
        setCompanyHistory([]);
        toast(res.data.message);
        setIsLoading(false);
      } else {
        console.log(res.data.message);
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const getCompanieHistory = async (id) => {
    try {
      // https://application.eterp.in/company/history/master/1
      let res = await axios(
        `https://application.eterp.in/company/history/master/${id}`
      );
      console.log(res);
      if (res.data.success) {
        setCompanyHistory(res.data.data);

        console.log(res.data.data);
      } else {
        console.log(res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageClick = () => {
    // Trigger input file selection
    document.getElementById("fileInput").click();
  };

  const getSettings = async (client) => {
    try {
      let res = await axios.get(`${base_url}settings/${client}`);
      console.log(res?.data, "res.data");
      if (res.data.success) {
        setIsExhebtionAccess(res?.data?.data?.is_exhibtion_acces);
        setIsEshowAcces(res?.data?.data?.is_eshow_acces);
      }
      // //settings by avinash sir
      //   is_exhibtion_acces: false,
      //   //settings by avinash sir
      //   is_eshow_acces: false,
    } catch (err) {
      console.log(err);
    }
  };

  const addSettings = async (payload) => {
    try {
      let res = await axios.post(
        `${base_url}settings/${selected_company?.key}`,
        payload
      );
      toast(res.data.message);
    } catch (err) {
      console.log(err);
    }
  };

  const getCompanyAccess = async (id) => {
    try {
      setLoadingAccess(true);

      const response = await axios.get(
        `https://application.eterp.in/companymenuaccess/master/${id}`
      );

      setAccessData(response.data?.data || []); // adjust if API structure differs
      setAccessSheetVisible(true); // open modal
    } catch (error) {
      console.error("Failed to fetch company access:", error);
    } finally {
      setLoadingAccess(false);
    }
  };

  const toggleAccess = (menuId, subpanelId = null, subtitleId = null) => {
    const updatedData = accessData.map((menu) => {
      if (menu.id === menuId) {
        // Toggle main menu
        if (!subpanelId && !subtitleId) {
          const newMenuState = !menu.is_active;
          const updatedSubpanels = menu.subpanels.map((sub) => ({
            ...sub,
            is_active: newMenuState,
            subtitles: sub.subtitles.map((st) => ({
              ...st,
              is_active: newMenuState,
            })),
          }));
          return {
            ...menu,
            is_active: newMenuState,
            subpanels: updatedSubpanels,
          };
        }

        // Toggle subpanel
        if (subpanelId && !subtitleId) {
          const updatedSubpanels = menu.subpanels.map((sub) => {
            if (sub.id === subpanelId) {
              const newSubState = !sub.is_active;
              const updatedSubtitles = sub.subtitles.map((st) => ({
                ...st,
                is_active: newSubState,
              }));
              return {
                ...sub,
                is_active: newSubState,
                subtitles: updatedSubtitles,
              };
            }
            return sub;
          });

          // Update main menu state if needed (optional: you can keep menu.active = true if any subpanel active)
          const menuActive = updatedSubpanels.some((s) => s.is_active);
          return {
            ...menu,
            subpanels: updatedSubpanels,
            is_active: menuActive,
          };
        }

        // Toggle subtitle
        if (subpanelId && subtitleId) {
          const updatedSubpanels = menu.subpanels.map((sub) => {
            if (sub.id === subpanelId) {
              const updatedSubtitles = sub.subtitles.map((st) =>
                st.id === subtitleId ? { ...st, is_active: !st.is_active } : st
              );
              // Update subpanel active if all subtitles are inactive/active
              const subActive = updatedSubtitles.some((st) => st.is_active);
              return {
                ...sub,
                subtitles: updatedSubtitles,
                is_active: subActive,
              };
            }
            return sub;
          });

          // Update main menu active if any subpanel is active
          const menuActive = updatedSubpanels.some((s) => s.is_active);
          return {
            ...menu,
            subpanels: updatedSubpanels,
            is_active: menuActive,
          };
        }
      }
      return menu;
    });

    setAccessData(updatedData);
  };

  const saveAccessChanges = async (id) => {
    setloading(true);
    try {
      const payload = accessData.map((menu) => ({
        id: menu.id,
        is_active: menu.is_active ? 1 : 0,
        subpanels:
          menu.subpanels?.map((sub) => ({
            id: sub.id,
            is_active: sub.is_active ? 1 : 0,
            subtitles:
              sub.subtitles?.map((st) => ({
                id: st.id,
                is_active: st.is_active ? 1 : 0,
              })) || [],
          })) || [],
      }));

      const res = await axios.patch(
        `https://application.eterp.in/companymenuaccess/master/${id}`,
        payload
      );

      if (res?.data?.success) {
        toast.success(res?.data?.message);
        setAccessSheetVisible(false);
        setloading(false);
      }
      // Alert.alert("Success", "Company access updated successfully");
    } catch (err) {
      setloading(false);
      console.log("Update Access Error:", err);
      // Alert.alert("Error", "Failed to update access");
    }
  };

  const [syncing, setSyncing] = useState(false)

  const runCheckandUpdates = (key) => {
    setSyncing(true);
    handleOpenSync()
    axios
      .post(`${base_url}checkandupdate/${key}`, {
        key: key,
        migrationMode: "upfront",
      })
      .then(() => {
        setSyncing(false);
        // setSuccessMessage("Database Integration Successful!");
        handleCloseSync()
      })
      .catch(() => {
        setSyncing(false);
        // setErrorMessage("Database Sync Failed!");
      });
  };


  const runNewMigrations = (key) => {
    setSyncing(true);
    handleOpenSync();
    axios.post(`${base_url}migrations/run/master?databaseKey=${encodeURIComponent(key)}`, {
      key: key,
    })
      .then(() => {
        setSyncing(false);
        // setSuccessMessage("Database Integration Successful!");
        handleCloseSync()
      })
      .catch((error) => {
        setApiError({ Error: error?.response?.data?.message });
        setSyncing(false);
        // handleCloseSync();
        console.log("in migration:", error)
        // setErrorMessage("Database Sync Failed!");
      });
  };

  useEffect(() => {
    getCompanies();
  }, []);

  // const [imagestorageData, setImageStorageData] = useState({});

  // const GetImageStorageStatus = async (dbkey) => {
  //   try {
  //     setLoadingAccess(true);

  //     const response = await axios.get(
  //       `https://application.eterp.in/files/storagestatus/${dbkey}`
  //     );

  //     console.log("in storege", response)

  //     setImageStorageData(response?.data);
  //   } catch (error) {
  //     console.error("Failed to fetch company access:", error);
  //   } finally {
  //     setLoadingAccess(false);
  //   }
  // };
  const [storageData, setStorageData] = useState({});
  const [loadingStorage, setLoadingStorage] = useState(false);

  const getStorageStatus = async (dbkey) => {
    if (!dbkey) return;

    try {
      setLoadingStorage(true);

      const response = await axios.get(
        `https://application.eterp.in/files/getCombinedStorage/${encodeURIComponent(dbkey)}`
      );

      setStorageData(response.data);
    } catch (error) {
      console.error(
        "Failed to fetch database storage:",
        error.response?.data || error.message
      );
    } finally {
      setLoadingStorage(false);
    }
  };



  const downloadQRCodePDF = async (value, name) => {

    const qrDataUrl = await QRCode.toDataURL(value, { margin: 1, width: 500 });

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();

    pdf.setFont("helvetica", "bold");
    pdf.text(name, pageWidth / 2, 20, { align: "center" });

    pdf.addImage(qrDataUrl, 'PNG', (pageWidth - 80) / 2, 30, 80, 80);

    pdf.save(`qr-code-${Date.now()}.pdf`);
  };

  const stickyLeft = {
    position: "sticky",
    left: 0,
    zIndex: 2,
    minWidth: 160,
    width: 160,
    backgroundColor: "inherit",
    backgroundClip: "padding-box",
    borderRight: "0px solid #ddd",
  };

  const stickyRight = {
    position: "sticky",
    right: 0,
    zIndex: 2,
    minWidth: 55,
    width: 55,
    textAlign: "center",
    backgroundColor: "inherit",
    backgroundClip: "padding-box",
    borderLeft: "0px solid #ddd",
  };

  return (
    <div>
      <ToastContainer />

      <CompanyHeader
        tosearch={tosearch}
        setToSearch={setToSearch}
        suggestions={suggestions}
        searchCompany={searchCompany}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        handleFilter={handleFilter}
        filter_companies={filter_companies}
      />

      <div style={{ margin: 20 }}>
        <TableContainer
          // component={Paper}
          // sx={{
          //   boxShadow: 3,
          //   borderRadius: 2,
          //   overflowX: "auto",
          // }}
          component={Paper}
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            width: "100%",
            maxWidth: "100%",
            overflowX: "auto",
            position: "relative",
          }}
        >
          {/* <Table
            sx={{
              minWidth: 650,
              "& th, & td": {
                whiteSpace: "wrap",
              },
            }}
            size="small"
            aria-label="companies table"
            
          > */}
          <Table
            stickyHeader
            sx={{
              minWidth: 1200,
              borderCollapse: "separate",
              borderSpacing: 0,
              "& th, & td": {
                whiteSpace: "nowrap",
              },
            }}
            size="small"
            aria-label="companies table"
          >
            <TableHead
              sx={{
                backgroundColor: "#2db7e8",
                "& th": {
                  color: "#fff",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
                },
              }}
            >
              <TableRow>
                {/* {[
                  "Company Name",
                  "Code",
                  // "State",
                  "City",
                  "GST No",
                  "Mobile No",
                  "Creation Date",
                  "Expiry Date",
                  "No. of Devices",
                  "APIs",
                  // "Database",
                  "",
                ].map((header) => (
                  <TableCell key={header}>{header}</TableCell>
                ))} */}
                <TableCell
                  sx={{
                    ...stickyLeft,
                    zIndex: 4,
                    backgroundColor: "#2db7e8",
                  }}
                >
                  Company Name
                </TableCell>

                <TableCell sx={{backgroundColor: "#2db7e8"}}>Code</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}>City</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}>GST No</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}>Mobile No</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}>Creation Date</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}>Expiry Date</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}>No. of Devices</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}>APIs</TableCell>
                <TableCell sx={{backgroundColor: "#2db7e8"}}></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filter_companies.map((row) => {
                const diffInDays = dayjs(row.renewable_date, "DD/MM/YYYY").diff(
                  dayjs(),
                  "day"
                );

                let rowBg = "#ffffff";

                if (!row.isActive) {
                  rowBg = "#d1d1d1";
                } else if (diffInDays <= 0) {
                  rowBg = "#ff6b6b";
                } else if (diffInDays <= 15) {
                  rowBg = "#ffd56b";
                }

                return (
                  <TableRow
                    key={row.company_name}
                    sx={{
                      backgroundColor: rowBg,
                      transition: "0.3s",
                      "&:hover": row.isActive
                        ? { backgroundColor: "#eaf4ff" }
                        : { backgroundColor: rowBg, cursor: "not-allowed" },
                    }}
                  >
                    {/* <TableCell>{row.company_name}</TableCell> */}
                    <TableCell
                      sx={{
                        ...stickyLeft,
                        backgroundColor: rowBg,
                        "tr:hover &": {
                          backgroundColor: row.isActive
                            ? "#eaf4ff"
                            : rowBg,
                        },
                      }}
                    >
                      {row.company_name}
                    </TableCell>
                    <TableCell>{row.company_code}</TableCell>
                    {/* <TableCell>{row.state}</TableCell> */}
                    <TableCell>{row.city}</TableCell>
                    <TableCell>{row.gst_no}</TableCell>
                    <TableCell>{row.mobile_no}</TableCell>
                    <TableCell>
                      {row.createdAt
                        ?.split("T")[0]
                        .split("-")
                        .reverse()
                        .join("/")}
                    </TableCell>
                    <TableCell>{row.renewable_date}</TableCell>
                    <TableCell>{row.no_of_devices}</TableCell>
                    <TableCell>
                      {row?.isActive ? (
                        row.key ? (
                          // CASE 1: Active + key exists → Eye icon
                          <FaRegEye
                            size={22}
                            color="#2db7e8"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedCompany(row);
                              handleOpen1();
                            }}
                          />
                        ) : (
                          // CASE 2: Active + key missing → Create DB icon
                          <BsDatabaseFillAdd
                            size={22}
                            color="#28a745"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedCompany(row);
                              handleOpen(); // dialog to create DB
                            }}
                          />
                        )
                      ) : (
                        // CASE 3: Not active → Do Not Disturb
                        <MdDoNotDisturb size={22} color="red" />
                      )}
                    </TableCell>
                    {/* <TableCell>{row.database_name || "-"}</TableCell> */}
                    {/* <TableCell>
                      <BsThreeDotsVertical */}
                    <TableCell
                      sx={{
                        ...stickyRight,
                        backgroundColor: rowBg,
                        "tr:hover &": {
                          backgroundColor: row.isActive
                            ? "#eaf4ff"
                            : rowBg,
                        },
                      }}
                    >
                      <BsThreeDotsVertical
                        size={22}
                        style={{ cursor: "pointer" }}
                        onClick={(event) => {
                          setSelectedCompany(row);
                          getSettings(row?.key);
                          handleClick(event);
                        }}
                      />

                      <Menu
                        anchorEl={anchorEl}
                        open={open_menu}
                        onClose={handleCloseMenu}
                        anchorOrigin={{ horizontal: "right", vertical: "top" }}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        sx={{
                          "& .MuiPaper-root": {
                            borderRadius: 2,
                            minWidth: 180,
                          },
                        }}
                      >
                        {[
                          {
                            label: "Edit Company",
                            action: () => {
                              handleOpen2();
                              handleCloseMenu();
                            },
                          },
                          {
                            label: "Access",
                            action: () => {
                              setAccessSheetVisible(true);
                              getCompanyAccess(selected_company?.id);
                              handleCloseMenu();
                              // setIsWaterMarkLogo(
                              //   selected_company.isWaterMarkLogo
                              // );
                              // setIsSetWIse(selected_company.isSetWise);
                              companySelector(selected_company.company_name);
                            },
                          },
                          {
                            label: "Users",
                            action: () => {
                              handleCloseMenu();
                              companySelector(selected_company.company_name);
                              navigate(`/users/${selected_company?.key}`);
                            },
                          },


                          {
                            label: "Run Check & Updates",
                            action: () => {

                              handleCloseMenu();
                              runCheckandUpdates(selected_company?.key);
                              // handleOpenSync()
                            },
                          },

                          {
                            label: "Run new Migration's",
                            action: () => {

                              handleCloseMenu();
                              runNewMigrations(selected_company?.key);
                              // handleOpenSync()
                            },
                          },

                          {
                            label: "Et-Sign Users",
                            action: () => {
                              handleCloseMenu();
                              companySelector(selected_company.company_name);
                              navigate(`/etsignusers/${selected_company?.id}`);
                            },
                          },

                          {
                            label: "License",
                            action: () => {
                              handleCloseMenu();
                              companySelector(selected_company.company_name);
                              navigate(`/licenses/${selected_company.id}`);
                            },
                          },
                          !selected_company.key && {
                            label: "Create Database",
                            action: () => {
                              handleCloseMenu();
                              companySelector(selected_company.company_name);
                              handleOpen();
                            },
                          },
                          {
                            label: "Renew Company",
                            action: () => {
                              handleOpenRC();
                              handleCloseMenu();
                              getCompanieHistory(selected_company.id);
                            },
                          },
                          {
                            label: "Settings",
                            action: () => {
                              handleOpenRC1();
                              handleCloseMenu();
                              setIsWaterMarkLogo(
                                selected_company.isWaterMarkLogo
                              );
                              setIsSetWIse(selected_company.isSetWise);
                              companySelector(selected_company.company_name);
                            },
                          },

                          // {
                          //   label: "Image Storage status",
                          //   action: () => {
                          //     handleOpen2s();
                          //     GetImageStorageStatus(selected_company?.key);
                          //     handleCloseMenu();
                          //   },
                          // },
                          {
                            label: "Storage Status",
                            action: () => {
                              handleOpen3s();
                              getStorageStatus(selected_company?.key);
                              handleCloseMenu();
                            },
                          },

                          {
                            label: selected_company?.isActive
                              ? "Deactive"
                              : "Active",
                            action: () => {
                              toggleActiveCompany(
                                selected_company?.id,
                                !selected_company?.isActive
                              );

                              handleCloseMenu();
                            },
                          },


                          {
                            label: "QR Code",
                            action: () => {
                              // toggleActiveCompany(
                              //   selected_company?.id,
                              //   !selected_company?.isActive
                              // );

                              console.log({ selected_company }, "selectred company")
                              downloadQRCodePDF(selected_company?.qr_code, selected_company?.company_name);
                              handleCloseMenu();
                            },
                          },
                        ]
                          .filter(Boolean)
                          .map((item) => {
                            // console.log({ item, row });
                            return (
                              <MenuItem
                                disabled={
                                  selected_company.isActive === 0 &&
                                  item.label !== "Deactive" &&
                                  item.label !== "Active"
                                }
                                key={item.label}
                                onClick={item.action}
                                sx={{
                                  "&:hover": { backgroundColor: "#e3f2fd" },
                                  fontWeight: 500,
                                }}
                              >
                                {item.label}
                              </MenuItem>
                            );
                          })}
                      </Menu>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>


      {/* modal for api details */}
      <Modal
        open={open1}
        onClose={handleClose1}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
      >
        <Box
          sx={{
            ...style2,
            width: { xs: "95%", sm: "90%", md: "80%" },
            maxHeight: "90vh",
            overflowY: "auto",
            p: 3,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {selected_company.company_name} - API Details
                </span>
                <ExcelDownloadButton
                  data={sortedApis.map((el) => ({
                    ...el,
                    api:
                      base_url +
                      el.api +
                      "/" +
                      selected_company?.key,
                    clear_api:
                      el.clear_api.length > 0
                        ? base_url +
                        el.clear_api +
                        "/" +
                        selected_company?.key
                        : "",
                    post_response_api:
                      el.post_response_api.length > 0
                        ? base_url +
                        el.post_response_api +
                        "/" +
                        selected_company?.key
                        : "",
                    update_api:
                      el.update_api.length > 0
                        ? base_url +
                        el.update_api +
                        "/" +
                        selected_company?.key
                        : "",
                  }))}
                  fileName={`${selected_company.company_name} - API Details`}
                />
              </div>
              <GrClose style={{ cursor: "pointer" }} onClick={handleClose1} />
            </div>
          </Typography>

          <Typography id="modal-modal-description">
            <TableContainer
              component={Paper}
              sx={{ maxHeight: "70vh", overflow: "auto", borderRadius: 2 }}
            >
              <Table sx={{ minWidth: 650 }} stickyHeader aria-label="api-table">
                <TableHead sx={{ backgroundColor: "#2db7e8" }}>
                  <TableRow>
                    {[
                      "Type",
                      "Name",
                      "API",
                      "CLEAR API",
                      "POST RESPONSE API",
                      "UPDATE API",
                      // "MESSAGE",
                    ].map((head) => (
                      <TableCell
                        key={head}
                        sx={{ color: "#2db7e8", fontWeight: 600 }}
                      >
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {sortedApis.map((row) => (
                    <TableRow key={row.name} hover>
                      <TableCell>{row.type}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      {[
                        "api",
                        "clear_api",
                        "post_response_api",
                        "update_api",
                        // "message",
                      ].map((key) => (
                        <TableCell key={key}>
                          {row[key] && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                flexWrap: "wrap",
                              }}
                            >
                              <span style={{ wordBreak: "break-all" }}>
                                {(selected_company?.key === "test"
                                  ? "https://application.eterp.in/"
                                  : base_url) +
                                  row[key] +
                                  "/" +
                                  selected_company?.key}
                              </span>
                              <CopyToClipboard
                                text={
                                  (selected_company?.key === "test"
                                    ? "https://application.eterp.in/"
                                    : base_url) +
                                  row[key] +
                                  "/" +
                                  selected_company?.key
                                }
                                onCopy={() =>
                                  setCopiedEndPoint(
                                    row[key] + selected_company.key
                                  )
                                }
                              >
                                {copied_endpoint ===
                                  row[key] + selected_company.key ? (
                                  <p style={{ color: "#52b03b", margin: 0 }}>
                                    Copied
                                  </p>
                                ) : (
                                  <MdOutlineFileCopy
                                    size={20}
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                              </CopyToClipboard>
                            </div>
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Typography>
        </Box>
      </Modal>


      {/* modal for add databases */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            ...style,
            width: { xs: "95%", sm: "80%", md: "60%" },
            maxWidth: 600,
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span style={{ fontWeight: 600, fontSize: "1.1rem" }}>
                {company.name} - Create Database
              </span>
              <GrClose style={{ cursor: "pointer" }} onClick={handleClose} />
            </div>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div
              style={{
                padding: 20,
                border: "2px solid #2db7e8",
                borderRadius: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 20,
                width: "100%",
              }}
            >
              {Inputs.map((el) => (
                <input
                  key={el.name}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    maxWidth: 400,
                    padding: 12,
                    borderRadius: 6,
                    border: "1px solid #ccc",
                    outline: "none",
                    transition: "0.2s",
                  }}
                  placeholder={el.placeholder}
                  name={el.name}
                  onFocus={(e) => (e.target.style.borderColor = "#2db7e8")}
                  onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                />
              ))}

              <button
                disabled={isLoading}
                onClick={() => addDatabase(selected_company.id)}
                style={{
                  width: "100%",
                  maxWidth: 400,
                  backgroundColor: "#2db7e8",
                  border: "none",
                  borderRadius: 6,
                  color: "#fff",
                  padding: 12,
                  fontSize: 16,
                  cursor: isLoading ? "not-allowed" : "pointer",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#26a0d6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#2db7e8")
                }
              >
                {isLoading ? (
                  <ClipLoader
                    color={color}
                    loading={isLoading}
                    cssOverride={override}
                    size={20}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                ) : (
                  "Create Database"
                )}
              </button>
            </div>
          </Typography>
        </Box>
      </Modal>



      {/* modal for renew company */}
      <Modal
        open={openRC}
        onClose={handleCloseRC}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            border: "2px solid #2db7e8",
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
            width: "75%",
            maxHeight: "90vh",
            overflowY: "auto",
            p: 4,
          }}
        >
          {/* ===== Sticky Header ===== */}
          <div
            style={{
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 10,
              paddingBottom: 10,
              borderBottom: "2px solid #2db7e8",
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  {selected_company.company_name} - <b>Renew</b>
                  <ExcelDownloadButton
                    data={[
                      ...company_history.map((row) => ({
                        "Entry Date": row.date,
                        "Expiry Date": row.expiry_date,
                        "Renewable Date": row.renewable_date,
                        Remark: row.remark,
                      })),
                    ]}
                    fileName={`${selected_company.company_name} - Renewable History`}
                  />
                </div>
                <GrClose
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleCloseRC();
                    setCompanyHistory([]);
                  }}
                />
              </div>
            </Typography>
          </div>

          {/* ===== Modal Body ===== */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div
              style={{
                padding: 20,
                border: "2px solid #2db7e8",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 20,
                backgroundColor: "#e0f7fa",
              }}
            >
              {/* Date + Remark Inputs */}
              <div
                style={{
                  display: "flex",
                  gap: 20,
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  width: "100%",
                  flexWrap: "wrap",
                }}
              >
                <DemoItem label="Expiry Date">
                  <DatePicker
                    disabled
                    format="DD/MM/YYYY"
                    defaultValue={dayjs(
                      selected_company?.renewable_date,
                      "DD/MM/YYYY"
                    )}
                  />
                </DemoItem>

                <DemoItem label="Renewable Date">
                  <DatePicker
                    onChange={(date) => {
                      const req_date = dayjs(date.$d).format("DD/MM/YYYY");
                      setRenewableDate(req_date);
                    }}
                    format="DD/MM/YYYY"
                    defaultValue={dayjs(
                      selected_company?.renewable_date,
                      "DD/MM/YYYY"
                    )}
                    minDate={dayjs(
                      selected_company?.renewable_date,
                      "DD/MM/YYYY"
                    )}
                  />
                </DemoItem>

                <DemoItem label="Remark">
                  <Textarea
                    placeholder="Write remark here..."
                    onChange={(e) => setRemark(e.target.value)}
                    style={{ width: "100%" }}
                    minRows={2}
                    variant="outlined"
                  />
                </DemoItem>
              </div>

              {/* Renew Button */}
              <button
                disabled={isLoading}
                onClick={() =>
                  renewCompany(selected_company.id, {
                    date: renewable_date,
                    remark: remark,
                  })
                }
                style={{
                  width: "82%",
                  backgroundColor: "#2db7e8",
                  border: "none",
                  color: "#fff",
                  padding: 10,
                  borderRadius: 8,
                  cursor: "pointer",
                  fontWeight: "600",
                  transition: "0.3s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#2196f3")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#2db7e8")
                }
              >
                {isLoading ? (
                  <ClipLoader
                    color="#fff"
                    loading={isLoading}
                    size={20}
                    aria-label="Loading Spinner"
                  />
                ) : (
                  "Renew"
                )}
              </button>

              {/* Renewal History Table */}
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: "10px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  width: "100%",
                }}
              >
                <Table size="small" aria-label="renewal history table">
                  <TableHead
                    sx={{
                      backgroundColor: "#2db7e8",
                      position: "sticky",
                      top: 0,
                      zIndex: 5,
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                        Entry Date
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                        Expiry Date
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                        Renewable Date
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                        Remark
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {company_history.map((row, ind) => (
                      <TableRow
                        key={ind}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        <TableCell>{row.date}</TableCell>
                        <TableCell>{row.expiry_date}</TableCell>
                        <TableCell>{row.renewable_date}</TableCell>
                        <TableCell>{row.remark}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Typography>
        </Box>
      </Modal>



      {/* modal for settings */}
      <Modal
        open={openRC1}
        onClose={handleCloseRC1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: 500 },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            outline: "none",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
              {selected_company.company_name} - Settings
            </Typography>
            <GrClose
              onClick={() => {
                handleCloseRC1();
                setCompanyHistory([]);
              }}
              style={{
                cursor: "pointer",
                fontSize: "1.3rem",
                transition: "0.2s",
              }}
              onMouseOver={(e) => (e.currentTarget.style.color = "#f44336")}
              onMouseOut={(e) => (e.currentTarget.style.color = "inherit")}
            />
          </Box>

          {/* Content */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              border: "2px solid #2db7e8",
              borderRadius: 2,
              p: 3,
              bgcolor: "#f9f9f9",
            }}
          >
            {/* Switches */}
            <FormControlLabel
              control={
                <Switch
                  checked={isSetWise}
                  onChange={() => setIsSetWIse(!isSetWise)}
                  color="primary"
                />
              }
              label="Design Set Wise (Catalogue)"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={isWaterMarkLogo}
                  onChange={() => setIsWaterMarkLogo(!isWaterMarkLogo)}
                  color="primary"
                />
              }
              label="Water Mark Logo"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={is_exhibtion_acces}
                  onChange={() => {
                    setIsExhebtionAccess(!is_exhibtion_acces);
                    addSettings({ is_exhibtion_acces: !is_exhibtion_acces });
                  }}
                  color="primary"
                />
              }
              label="Exhibition Access"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={is_eshow_acces}
                  onChange={() => {
                    setIsEshowAcces(!is_eshow_acces);
                    addSettings({ is_eshow_acces: !is_eshow_acces });
                  }}
                  color="primary"
                />
              }
              label="Eshow Access"
            />

            {/* Save Button */}
            <Button
              variant="contained"
              sx={{
                bgcolor: "#2db7e8",
                "&:hover": { bgcolor: "#29a3d1" },
                width: "100%",
                py: 1.5,
                mt: 1,
              }}
              disabled={isLoading}
              onClick={() =>
                updateCompany(selected_company.id, {
                  isSetWise,
                  isWaterMarkLogo,
                })
              }
            >
              {isLoading ? (
                <ClipLoader
                  color="#fff"
                  loading={isLoading}
                  size={20}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              ) : (
                "Save Changes"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>



      {/* modal for company update */}
      <Modal
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          top: 0,
        }}
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style2,
            width: { xs: "95%", sm: "80%", md: "60%" },
            maxHeight: "90%",
            overflowY: "auto",
            bgcolor: "#fff",
            borderRadius: 3,
            p: 3,
            boxShadow: 24,
            // position: "relative",
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              Update Company
              <GrClose
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleClose2();
                  setSelectedImage("");
                }}
              />
            </div>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div
              style={{
                padding: 20,
                border: "2px solid #2db7e8",
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 20,
                backgroundColor: "#f9f9f9",
              }}
            >
              <ToastContainer />

              {/* Image uploader */}
              <div
                onClick={handleImageClick}
                style={{
                  width: 120,
                  height: 120,
                  borderRadius: 10,
                  background: "#e0e0e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                }}
              >
                <input
                  style={{ display: "none" }}
                  className="file-uploader"
                  id="fileInput"
                  type="file"
                  onChange={handleFileChange}
                  accept="image/png"
                />
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : selected_company?.logo ? (
                  <img
                    src={img_url + selected_company?.logo}
                    alt="logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <h6 style={{ color: "#aaa" }}>Logo</h6>
                )}
              </div>

              {/* Inputs */}
              {EditInputs.map((el) => (
                <div
                  key={el.name}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <label style={{ marginBottom: 5 }}>{el.placeholder}</label>
                  <input
                    disabled={el?.disabled}
                    defaultValue={selected_company[el.name]}
                    onChange={handleEditCompany}
                    style={{
                      width: "100%",
                      padding: 10,
                      borderRadius: 5,
                      border: "1px solid #ccc",
                      outline: "none",
                      transition: "0.3s all",
                    }}
                    placeholder={el.placeholder}
                    name={el.name}
                    onFocus={(e) =>
                      (e.target.style.border = "1px solid #2db7e8")
                    }
                    onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                  />
                </div>
              ))}

              {/* Update button */}
              <button
                disabled={isLoading}
                onClick={() => updateCompany(selected_company.id, edit_company)}
                style={{
                  width: "100%",
                  backgroundColor: "#2db7e8",
                  border: "none",
                  color: "#fff",
                  padding: 12,
                  fontSize: 16,
                  borderRadius: 5,
                  cursor: isLoading ? "not-allowed" : "pointer",
                  transition: "0.3s all",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#25a0d6")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#2db7e8")
                }
              >
                {isLoading ? (
                  <ClipLoader
                    color={color}
                    loading={isLoading}
                    cssOverride={override}
                    size={20}
                  />
                ) : (
                  "Update Company"
                )}
              </button>
            </div>
          </Typography>
        </Box>
      </Modal>


      {/* model forsee storage details */}
      {/* <Modal
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          top: 0,
        }}
        open={open2s}
        onClose={handleClose2s}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {loadingAccess ? (
          <StorageStatusLoader />
        ) : (
          <StorageStatusWidget loading={loadingAccess}
            onRefresh={() => GetImageStorageStatus(selected_company?.key)} data={imagestorageData} />
        )}
      </Modal> */}


      {/* Database Storage Modal */}
      {/* <Modal
        open={open3s}
        onClose={handleClose3s}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 450,
            maxHeight: "95dvh",
            height: "auto",
            outline: "none",
            overflowY: "auto",
            overflowX: "hidden",
            borderRadius: 2,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          {loadingStorage && !storageData ? (
            <StorageStatusLoader />
          ) : (
            <DatabaseStorageWidget
              data={storageData}
              loading={loadingStorage}
              onRefresh={() =>
                getStorageStatus(selected_company?.key)
              }
              onClose={handleClose3s}
            />
          )}
        </Box>
      </Modal> */}


      <DatabaseStorageDialog
        open={open3s}
        onClose={handleClose3s}
        data={storageData}
        loading={loadingStorage}
        onRefresh={() =>
          getStorageStatus(selected_company?.key)
        }
      />


      {/* <Modal
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          top: 0,
        }}
        open={openSync}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleCloseSync();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Lottie animationData={databaseAnim} style={{ width: 280 }} />
          <Typography
            variant="h5"
            sx={{ mt: 3, fontWeight: 800, color: "#2db7e8", }}
          >
            Syncing Database
          </Typography>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: "#2db7e8", maxWidth: 450 }}
          >
            Configuring your tables and environment.
          </Typography>
        </Box>
      </Modal> */}

      {/* modal for syncing database viwew */}
      <Modal
        open={openSync}
        // Prevents closing on backdrop click or escape key
        // onClose={(event, reason) => {
        //   if (reason !== "backdropClick") handleCloseSync();
        // }}

        onClose={handleCloseSync}
        disableEscapeKeyDown
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              backdropFilter: "blur(4px)", // Blurs the background for a modern feel
            },
          },
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            p: 5,
            mx: 2,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(10px)",
            borderRadius: "24px", // Extra rounded corners for a modern look
            boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
            maxWidth: 400,
            border: "1px solid rgba(255, 255, 255, 0.3)",
          }}
        >
          {/* Animation Container */}
          <Box sx={{ transform: "scale(1.1)", mb: -2 }}>
            <Lottie animationData={databaseAnim} style={{ width: 220 }} />
          </Box>

          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              background: "linear-gradient(45deg, #2db7e8, #1a73e8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              letterSpacing: "-0.5px",
              mb: 1,
            }}
          >
            Syncing Database
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              px: 2,
              lineHeight: 1.6,
              fontWeight: 500,
            }}
          >
            Configuring your tables and environment.
            <br />
            This will only take a moment.
            {ApiError?.Error && (
              <Typography
                variant="body2"
                sx={{
                  color: "error.main",
                  mt: 1.5,
                  px: 2,
                  fontWeight: 600,
                  lineHeight: 1.5,
                }}
              >
                {ApiError.Error}
              </Typography>
            )}
          </Typography>

          {/* Subtle custom loader for extra "modern" feel */}
          <Box
            sx={{
              width: "60%",
              height: 4,
              bgcolor: "#e0e0e0",
              borderRadius: 2,
              mt: 4,
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: "30%",
                height: "100%",
                bgcolor: "#2db7e8",
                borderRadius: 2,
                position: "absolute",
                animation: "moveProgress 2s infinite ease-in-out",
                "@keyframes moveProgress": {
                  "0%": { left: "-30%" },
                  "100%": { left: "100%" },
                },
              }}
            />
          </Box>
        </Box>
      </Modal>


      {/* model for access handling */}
      <UserMenuAccessModal
        open={accessSheetVisible}
        onClose={() => setAccessSheetVisible(false)}
        loadingAccess={loadingAccess}
        accessData={accessData}
        toggleAccess={toggleAccess}
        disabled={loading}
        saveAccessChanges={() => {
          console.log(selected_company.id, "selected");
          saveAccessChanges(selected_company.id);
        }}
      />
    </div>
  );
};
